<template>
	<div>
		<b-form-group>
			<template #label>
				<div class="">
					<p class="mb-0">{{ fieldData.question }} <span v-show="fieldData.is_required" class="text-danger"> *</span></p>
				</div>
			</template>
			<div class="input-group">
				<b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." />
			</div>
			<small v-show="fieldData.help">{{ fieldData.help }}</small>
		</b-form-group>
	</div>
</template>

<script>
import { BFormGroup, BFormFile } from 'bootstrap-vue';

export default {
	name: 'ImageFieldPreview',

	components: {
		BFormGroup,
		BFormFile,
	},

	props: {
		fieldData: {
			type: Object,
			default: () => ({
				question: '',
				min: '',
				max: '',
				is_required: false,
				help: '',
			}),
		},
	},
};
</script>

<style lang="scss" scoped></style>
